import { createAsyncThunk } from '@reduxjs/toolkit';
import { getNotifications as notificationsService } from './services';

export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const getNotifications = createAsyncThunk(
  GET_NOTIFICATIONS,
  notificationsService,
);
